


















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import FontAwesomeIcon from "@/components/FontAwesomeIcon.vue";
@Component({ components: { FontAwesomeIcon } })
export default class SubHeading extends Vue {
	@Prop({ type: String, default: "" }) readonly title!: string;
	@Prop(Array) readonly icon!: string[];
	@Prop({ type: Boolean, default: false }) readonly showIcon!: boolean;
}
